import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { COMPANY_ROUTES } from '../constants';
import FlowGuard from '../../shared/components/FlowGuard';

/**
 * JobSuccess Content Component
 * This component redirects to JobDetails with a success modal flag
 */
const JobSuccessContent: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Get job ID from location state
        const jobData = location.state?.jobData;
        console.log('JobSuccess received jobData:', jobData);

        // Try multiple possible ID fields
        const jobId = jobData?._id || jobData?.id || jobData?.job_id;
        console.log('Extracted jobId:', jobId);

        if (jobId) {
            // Navigate to JobDetails with showSuccessModal flag
            navigate(COMPANY_ROUTES.JOB_DETAILS(jobId), {
                state: { showSuccessModal: true }
            });
        } else {
            console.error('No job ID found in jobData:', jobData);
            // If no job ID, redirect to job postings
            navigate(COMPANY_ROUTES.JOB_POSTINGS);
        }
    }, [location.state, navigate]);

    // Show loading while redirecting
    return (
        <div className="flex items-center justify-center h-screen bg-[#F1F3F4]">
            <div className="text-center">
                <div className="w-16 h-16 border-4 border-[#015FA6] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-lg font-medium text-[#757575]" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    Redirecting...
                </p>
            </div>
        </div>
    );
};

/**
 * JobSuccess Page
 * Protected by FlowGuard - only accessible after job posting flow
 * Direct URL access redirects to job postings page
 */
const JobSuccess: React.FC = () => {
    return (
        <FlowGuard
            requiredStateKey="fromJobPosting"
            fallbackPath="/companies/jobs"
        >
            <JobSuccessContent />
        </FlowGuard>
    );
};

export default JobSuccess;
